import { ref } from 'vue'

const isOpen = ref(false)
const activeTab = ref<'marketing' | 'support'>('marketing')

export function useAudienceAIPanel() {
  const open = (tab?: 'marketing' | 'support') => {
    activeTab.value = tab ?? 'marketing'
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
  }

  const toggle = (tab?: 'marketing' | 'support') => {
    if (isOpen.value) {
      close()
    }
    else {
      open(tab)
    }
  }

  return { isOpen, activeTab, open, close, toggle }
}
